import Vue from "vue";
import Vuex from "vuex";
import forms from "./forms";
import auth from "./auth";
import account from "./account";
import service from "./service";
import campaigns from "./campaigns";
import contacts from "./contacts";
import tags from "./tags";
import templates from "./templates";
import billing from "./billing";
import dashboard from "./dashboard";
import user from "./user";
import history from "./history";
import importHistory from "./import-history";
import letters from "./letters";
import lettersTemplates from "./letters-templates";
import support from "./support";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    forms,
    auth,
    account,
    service,
    campaigns,
    contacts,
    tags,
    templates,
    billing,
    dashboard,
    user,
    history,
    importHistory,
    letters,
    lettersTemplates,
    support
  }
});
